import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CompanyGuard } from '@guards/company.guard';
import { AccountVerificationGuard } from '@guards/account-verification.guard';
import { LayoutModule } from '@layout/layout.module';
import { LayoutComponent } from '@layout/layout.component';

const routes: Routes = [
  {
    path: 'account-verification',
    loadChildren: () =>
      import('@private/account-verification/account-verification.module').then(
        (m) => m.AccountVerificationModule,
      ),
    canActivate: [AccountVerificationGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [CompanyGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'wallet' },
      {
        path: 'wallet',
        loadChildren: () =>
          import('@private/wallet/wallet.module').then((m) => m.WalletModule),
      },
      {
        path: 'student-payments',
        loadChildren: () =>
          import('@private/student-payments/student-payments.module').then(
            (m) => m.StudentPaymentsModule,
          ),
      },
      {
        path: 'payouts',
        loadChildren: () =>
          import('@private/payouts/payouts.module').then(
            (m) => m.PayoutsModule,
          ),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('@private/settings/settings.module').then(
            (m) => m.SettingsModule,
          ),
      },
      {
        path: 'bank-accounts',
        loadChildren: () =>
          import('@private/bank-accounts/bank-accounts.module').then(
            (m) => m.BankAccountsModule,
          ),
      },
      {
        path: 'providers',
        loadChildren: () =>
          import('@private/providers/providers.module').then(
            (m) => m.ProvidersModule,
          ),
      },
      {
        path: 'invoice-funds',
        loadChildren: () =>
          import('@private/invoice-funds/invoice-funds.module').then(
            (m) => m.InvoiceFundsModule,
          ),
      },
      {
        path: 'commission-request',
        loadChildren: () =>
          import('@private/commissions/commissions.module').then(
            (m) => m.CommissionsModule,
          ),
      },
      {
        path: 'storybook',
        loadChildren: () =>
          import('@private/storybook/storybook.module').then(
            (m) => m.StorybookModule,
          ),
      },
      {
        path: 'conversions',
        loadChildren: () =>
          import('@private/convert-funds/convert-funds.module').then(
            (m) => m.ConvertFundsModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [LayoutModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivateRoutingModule {}
